import { GetToken, TYPE_USER_TOKEN } from "./token_manager";
import { ObjectMap } from "@/utils/utils";
import { GlobalMessage } from "@/utils/message";
import { Config } from "@/config";

export class Result {
    code = 0;
    data = null;
    msg  = "";
    success = true;
    constructor(code, data, msg, success) {
        this.code = parseInt(code);
        this.data = data;
        this.msg  = msg;
        this.success = success;
    }
}

export class Request {
    constructor(method, url, data) {
        this.url = Config.domainApi + url;
        this.config = {
            headers: {"Content-Type": method == "GET" ? "application/x-www-form-urlencoded" : "application/json;charset='utf-8'" },
            method: method ? method : "GET",
            mode: "cors",
        };

        if (data) {
            if (this.config.method == "POST") {
                this.config.body = JSON.stringify(data);
            } else if (this.config.method == "GET") {
                this.url = this.url + "?" + ObjectMap(
                        (k, v) => {
                            if (v instanceof Array) {
                                return v.map((_v) => k + "=" + _v).join("&");
                            } else if (v instanceof Object) {
                                let keys = Object.keys(v)
                                return keys.map(name => k + "["+name+"]=" + v[name]).join("&");
                            } else {
                                return k + "=" + v;
                            }
                        },
                        data,
                        true,
                    ).join("&");
            }
        }
    }
    Fetch() {
        return fetch(this.url, this.config)
            .then((res) => res.json())
            .then((data) => {
                return new Result(data.code, data.data, data.msg, data.success);
            })
            .catch(() => {
                GlobalMessage.error("network error");
            });
    }
    AuthFetch() {
        this.config.headers.jwt = GetToken(TYPE_USER_TOKEN);
        return fetch(this.url, this.config)
            .then((res) => res.json())
            .then((data) => {
                return new Result(data.code, data.data, data.msg, data.success);
            })
            .catch(() => {
                GlobalMessage.error("network error");
            });
    }
    AuthFetchRaw() {
        this.config.headers.jwt = GetToken(TYPE_USER_TOKEN);
        return fetch(this.url, this.config).catch(() => {
                GlobalMessage.error("network error");
            });
    }
}
